import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React from "react";
import { PrimaryButton } from "./StyledComponents";
import * as Sentry from "@sentry/react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    Sentry.captureException(error, {
      extra: {
        errorInfo,
      },
    });
  }

  // Function to handle going back to the home page
  goToHomePage = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container component="main" maxWidth="md" sx={{ mt: 8 }}>
          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5" gutterBottom>
              Oops! Something went wrong.
            </Typography>
            <Typography variant="subtitle1">
              We're working on getting it fixed as soon as we can.
            </Typography>
            <Box mt={4}>
              <PrimaryButton onClick={this.goToHomePage}>Go Home</PrimaryButton>
            </Box>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

export class DatagridErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <DataGridPremium
          rows={[]}
          columns={[]}
          sx={{
            padding: "10px",
            height: "92.5%",
            minHeight: "500px",
            overflow: "auto",
          }}
        />
      );
    }

    return this.props.children;
  }
}
